<template lang="pug">
  #ReservationIndex.container-width
    h5.text-center.py-3.letter-spacing-6 我的預約
    .py-3
      b-card.border-0.mb-2.customerCard.overflow-hidden(
        bg-variant="light",
        v-for="(reserve,index) in reservations",
        :key="reserve.reservation_id",
        body-class="p-0"
      )
        .row.position-relative.no-gutters(
          :class="{ 'no-gutters': reserve.status === 0, 'align-items-center': reserve.status === 0 }"
        )
          .col-12
            .p-3
              p.mb-1(v-if="reserve.reserve_type_name !== null") {{ reserve.reserve_type_name }}
              p.mb-1(v-if="reserve.activity_name !== null") {{ reserve.activity_name }}
            hr.m-0.border-primary
            .p-3
              small.mb-2.d-block(v-if="reserve.activity_name !== null") 活動類型：{{ reserve.experience === 0 ? '到店體驗' : '線上體驗'}}
              small.mb-2.d-block 預約日期：{{ reserve.reserve_date }}
              small.mb-2.d-block 預約時間：{{ reserve.start_time }}～{{ reserve.end_time }}
              small.mb-2.d-block 預約專門店：{{ reserve.store_name }}
              small.mb-2.d-block 專屬CA：{{ reserve.sa_preferred_name }}
              small.mb-2.d-block 參與人數：{{ reserve.companion_number }}
              small.mb-2.d-block 預約狀態：{{ reserve.status === 'reserving' ? '預約中' : reserve.status === 'checked' ? '完成預約' : reserve.status === 'success' ? '到店諮詢' : '-' }}
      infinite-loading(
        @infinite="infiniteHandler",
        :identifier="infiniteId",
        spinner="bubbles"
      )
        .cursor-default(slot="no-more") 無更多資料
        .cursor-default(slot="no-results") 無更多資料
        .cursor-default(slot="error") 發生錯誤，請重整重試一次
</template>

<script>
import { mapState } from 'vuex';
import InfiniteLoading from 'vue-infinite-loading';

export default {
  name: 'ReservationIndex',
  components: {
    InfiniteLoading
  },
  data() {
    return {
      infiniteId: +new Date()
    };
  },
  created() {
    const vm = this;
    vm.$swal.fire({
      title: '請稍候，\n載入中',
      allowOutsideClick: false,
      willOpen: () => {
        this.$swal.showLoading();
      }
    });
    vm.$store.commit('member_reservation/resetHandler');
    vm.$swal.close();
    vm.$store.commit('toggleLoading', false);
  },
  methods: {
    infiniteHandler($state) {
      const vm = this;
      vm.$store.dispatch('member_reservation/getReservationHandler', {
        current_page: vm.pagination.current_page + 1,
        per_page: vm.pagination.per_page,
        status: 'checked'
      }).then(() => {
        if (vm.pagination.current_page !== vm.pagination.total_page) {
          $state.loaded();
        } else {
          $state.complete();
        }
      });
    }
  },
  computed: {
    ...mapState({
      reservations: (state) => state.member_reservation.reservations,
      pagination: (state) => state.member_reservation.pagination
    })
  }
};
</script>

<style>

</style>
